import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { CompanySidePanelDetails } from "./CompanySidePanelDetails";

interface CompanySidePanelProps {
  companyId: number
  trigger: JSX.Element
  onChange?: () => void
  fallbackIfNoPermission?: JSX.Element
}

export const CompanySidePanel = (props: CompanySidePanelProps) => {
  if (!site.permissions.addressBook.canAccess) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <DetailSidePanel
    apiCall={() => window.CoreApi.Company.GetSidePanelData(props.companyId)}
    apiKey="company"
    entityId={props.companyId}
    title={RESX.Company.resxCompany}
    footerContent={
      <ButtonPrimary href={routes.company_Detail(props.companyId).absolute} label={RESX.Buttons.DetailView} />
    }
    trigger={props.trigger}
  >
    {(company, refetch) => <CompanySidePanelDetails
      company={company}
      refetch={refetch}
      onChange={props.onChange}
      viewOnMap
    />}
  </DetailSidePanel>;
};

export const PromoterSidePanel = (props: CompanySidePanelProps) => {
  if (!site.permissions.addressBook.canAccess) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <DetailSidePanel
    apiCall={() => window.CoreApi.Company.GetSidePanelData(props.companyId)}
    apiKey="promoter"
    entityId={props.companyId}
    title={site.currentEnvironment.functionGroups.promoter.singular}
    footerContent={
      <ButtonPrimary href={routes.company_Detail(props.companyId).absolute} label={RESX.Buttons.DetailView} />
    }
    onOpen={props.onChange}
    trigger={props.trigger}
  >
    {(company, refetch) => <CompanySidePanelDetails
      company={company}
      refetch={refetch}
      onChange={props.onChange}
      viewOnMap={false}
    />}
  </DetailSidePanel>;
};

export const ArtistSidePanel = (props: CompanySidePanelProps) => {
  if (!site.permissions.addressBook.canAccess) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <DetailSidePanel
    apiCall={() => window.CoreApi.Company.GetSidePanelData(props.companyId)}
    apiKey="artist"
    entityId={props.companyId}
    title={site.currentEnvironment.functionGroups.artist.singular}
    footerContent={
      <ButtonPrimary href={routes.company_Detail(props.companyId).absolute} label={RESX.Buttons.DetailView} />
    }
    onOpen={props.onChange}
    trigger={props.trigger}
  >
    {(company, refetch) => <CompanySidePanelDetails
      company={company}
      refetch={refetch}
      onChange={props.onChange}
      viewOnMap={false}
    />}
  </DetailSidePanel>;
};
